import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageContainer } from '../../modules/page-container/page-container';
import { GridContainer, GridItem } from '../../visual-components/grid/grid';
import { HighlightBox } from '../../visual-components/highlight-box/highlight-box';
import { Spacer } from '../../visual-components/spacer/spacer';
import { Typography } from '../../visual-components/typography/typography';

export const Overview: React.FC = () => {
  const { t } = useTranslation();

  return (
    <PageContainer documentTitle={t('global.register')}>
      <GridContainer>
        <GridItem span="8">
          <Typography variant="headline-1">{t('register.title')}</Typography>
        </GridItem>
      </GridContainer>
      <Spacer size="08" />
      <GridContainer>
        <GridItem span="8">
          <Typography variant="maintext">{t('register.infoText')}</Typography>
        </GridItem>
      </GridContainer>
      <Spacer size="08" />
      <GridContainer>
        <GridItem span="4">
          <HighlightBox
            text={t('register.highlight.existingClient.text')}
            title={t('register.highlight.existingClient.title')}
            variant="generic"
            link={{
              icon: 'pen-box',
              text: t('register.fastRegister'),
              to: 'existing-client',
            }}
          />
        </GridItem>
        <GridItem span="4">
          <HighlightBox
            text={t('register.highlight.newClient.text')}
            title={t('register.highlight.newClient.title')}
            variant="generic"
            link={{
              icon: 'pen-box',
              text: t('register.toRegistration'),
              to: 'new-client',
            }}
          />
        </GridItem>
      </GridContainer>
    </PageContainer>
  );
};
